export const dental = [
  {
    name: 'Aetna Dental - High',
    ratingRegion: 0,
    biweeklySelf: 19.75,
    biweeklySelfPlus: 39.5,
    biweeklyFamily: 59.25,
    monthlySelf: 42.79,
    monthlySelfPlus: 85.58,
    monthlyFamily: 128.38,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - High',
    ratingRegion: 1,
    biweeklySelf: 17.93,
    biweeklySelfPlus: 35.86,
    biweeklyFamily: 53.78,
    monthlySelf: 38.85,
    monthlySelfPlus: 77.7,
    monthlyFamily: 116.52,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - High',
    ratingRegion: 2,
    biweeklySelf: 19.75,
    biweeklySelfPlus: 39.5,
    biweeklyFamily: 59.25,
    monthlySelf: 42.79,
    monthlySelfPlus: 85.58,
    monthlyFamily: 128.38,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - High',
    ratingRegion: 3,
    biweeklySelf: 21.01,
    biweeklySelfPlus: 42.01,
    biweeklyFamily: 63.02,
    monthlySelf: 45.52,
    monthlySelfPlus: 91.02,
    monthlyFamily: 136.54,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - High',
    ratingRegion: 4,
    biweeklySelf: 23.19,
    biweeklySelfPlus: 46.38,
    biweeklyFamily: 69.57,
    monthlySelf: 50.25,
    monthlySelfPlus: 100.49,
    monthlyFamily: 150.74,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - High',
    ratingRegion: 5,
    biweeklySelf: 25.19,
    biweeklySelfPlus: 50.35,
    biweeklyFamily: 75.53,
    monthlySelf: 54.58,
    monthlySelfPlus: 109.09,
    monthlyFamily: 163.65,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - Standard',
    ratingRegion: 0,
    biweeklySelf: 12.26,
    biweeklySelfPlus: 24.51,
    biweeklyFamily: 36.75,
    monthlySelf: 26.56,
    monthlySelfPlus: 53.11,
    monthlyFamily: 79.63,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - Standard',
    ratingRegion: 1,
    biweeklySelf: 11.14,
    biweeklySelfPlus: 22.27,
    biweeklyFamily: 33.41,
    monthlySelf: 24.14,
    monthlySelfPlus: 48.25,
    monthlyFamily: 72.39,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - Standard',
    ratingRegion: 2,
    biweeklySelf: 12.26,
    biweeklySelfPlus: 24.51,
    biweeklyFamily: 36.75,
    monthlySelf: 26.56,
    monthlySelfPlus: 53.11,
    monthlyFamily: 79.63,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - Standard',
    ratingRegion: 3,
    biweeklySelf: 13.03,
    biweeklySelfPlus: 26.06,
    biweeklyFamily: 39.09,
    monthlySelf: 28.23,
    monthlySelfPlus: 56.46,
    monthlyFamily: 84.7,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - Standard',
    ratingRegion: 4,
    biweeklySelf: 14.36,
    biweeklySelfPlus: 28.71,
    biweeklyFamily: 43.06,
    monthlySelf: 31.11,
    monthlySelfPlus: 62.21,
    monthlyFamily: 93.3,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Aetna Dental - Standard',
    ratingRegion: 5,
    biweeklySelf: 15.58,
    biweeklySelfPlus: 31.17,
    biweeklyFamily: 46.75,
    monthlySelf: 33.76,
    monthlySelfPlus: 67.54,
    monthlyFamily: 101.29,
    website: 'https://www.aetnafeds.com/fedvip-dental.php',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/8/8d/Aetna_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - High',
    ratingRegion: 0,
    biweeklySelf: 19.51,
    biweeklySelfPlus: 39.02,
    biweeklyFamily: 58.53,
    monthlySelf: 42.27,
    monthlySelfPlus: 84.54,
    monthlyFamily: 126.82,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - High',
    ratingRegion: 1,
    biweeklySelf: 19.51,
    biweeklySelfPlus: 39.02,
    biweeklyFamily: 58.53,
    monthlySelf: 42.27,
    monthlySelfPlus: 84.54,
    monthlyFamily: 126.82,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - High',
    ratingRegion: 2,
    biweeklySelf: 21.86,
    biweeklySelfPlus: 43.72,
    biweeklyFamily: 65.59,
    monthlySelf: 47.36,
    monthlySelfPlus: 94.73,
    monthlyFamily: 142.11,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - High',
    ratingRegion: 3,
    biweeklySelf: 23.79,
    biweeklySelfPlus: 47.57,
    biweeklyFamily: 71.36,
    monthlySelf: 51.55,
    monthlySelfPlus: 103.07,
    monthlyFamily: 154.61,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - High',
    ratingRegion: 4,
    biweeklySelf: 25.77,
    biweeklySelfPlus: 51.54,
    biweeklyFamily: 77.3,
    monthlySelf: 55.84,
    monthlySelfPlus: 111.67,
    monthlyFamily: 167.48,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - High',
    ratingRegion: 5,
    biweeklySelf: 28.84,
    biweeklySelfPlus: 57.69,
    biweeklyFamily: 86.53,
    monthlySelf: 62.49,
    monthlySelfPlus: 125,
    monthlyFamily: 187.48,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - Standard',
    ratingRegion: 0,
    biweeklySelf: 10.5,
    biweeklySelfPlus: 20.99,
    biweeklyFamily: 31.49,
    monthlySelf: 22.75,
    monthlySelfPlus: 45.48,
    monthlyFamily: 68.23,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - Standard',
    ratingRegion: 1,
    biweeklySelf: 10.5,
    biweeklySelfPlus: 20.99,
    biweeklyFamily: 31.49,
    monthlySelf: 22.75,
    monthlySelfPlus: 45.48,
    monthlyFamily: 68.23,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - Standard',
    ratingRegion: 2,
    biweeklySelf: 11.5,
    biweeklySelfPlus: 22.99,
    biweeklyFamily: 34.49,
    monthlySelf: 24.92,
    monthlySelfPlus: 49.81,
    monthlyFamily: 74.73,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - Standard',
    ratingRegion: 3,
    biweeklySelf: 13.06,
    biweeklySelfPlus: 26.12,
    biweeklyFamily: 39.18,
    monthlySelf: 28.3,
    monthlySelfPlus: 56.59,
    monthlyFamily: 84.89,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - Standard',
    ratingRegion: 4,
    biweeklySelf: 14.1,
    biweeklySelfPlus: 28.2,
    biweeklyFamily: 42.3,
    monthlySelf: 30.55,
    monthlySelfPlus: 61.1,
    monthlyFamily: 91.65,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Blue Cross Blue Shield FEP Dental - Standard',
    ratingRegion: 5,
    biweeklySelf: 15.56,
    biweeklySelfPlus: 31.13,
    biweeklyFamily: 46.69,
    monthlySelf: 33.71,
    monthlySelfPlus: 67.45,
    monthlyFamily: 101.16,
    website: 'https://www.bcbsfepdental.com/benefits',
    logo: 'https://upload.wikimedia.org/wikipedia/en/6/6f/Blue_Cross_Blue_Shield_Association_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - High',
    ratingRegion: 0,
    biweeklySelf: 27.3,
    biweeklySelfPlus: 54.6,
    biweeklyFamily: 81.9,
    monthlySelf: 59.15,
    monthlySelfPlus: 118.3,
    monthlyFamily: 177.45,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - High',
    ratingRegion: 1,
    biweeklySelf: 18.31,
    biweeklySelfPlus: 36.61,
    biweeklyFamily: 54.92,
    monthlySelf: 39.67,
    monthlySelfPlus: 79.32,
    monthlyFamily: 118.99,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - High',
    ratingRegion: 2,
    biweeklySelf: 20.07,
    biweeklySelfPlus: 40.14,
    biweeklyFamily: 60.21,
    monthlySelf: 43.49,
    monthlySelfPlus: 86.97,
    monthlyFamily: 130.46,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - High',
    ratingRegion: 3,
    biweeklySelf: 22.02,
    biweeklySelfPlus: 44.05,
    biweeklyFamily: 66.07,
    monthlySelf: 47.71,
    monthlySelfPlus: 95.44,
    monthlyFamily: 143.15,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - High',
    ratingRegion: 4,
    biweeklySelf: 23.43,
    biweeklySelfPlus: 46.87,
    biweeklyFamily: 70.3,
    monthlySelf: 50.77,
    monthlySelfPlus: 101.55,
    monthlyFamily: 152.32,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - High',
    ratingRegion: 5,
    biweeklySelf: 27.3,
    biweeklySelfPlus: 54.6,
    biweeklyFamily: 81.9,
    monthlySelf: 59.15,
    monthlySelfPlus: 118.3,
    monthlyFamily: 177.45,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - Standard',
    ratingRegion: 0,
    biweeklySelf: 14.65,
    biweeklySelfPlus: 29.3,
    biweeklyFamily: 43.95,
    monthlySelf: 31.74,
    monthlySelfPlus: 63.48,
    monthlyFamily: 95.23,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - Standard',
    ratingRegion: 1,
    biweeklySelf: 10.33,
    biweeklySelfPlus: 20.65,
    biweeklyFamily: 30.98,
    monthlySelf: 22.38,
    monthlySelfPlus: 44.74,
    monthlyFamily: 67.12,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - Standard',
    ratingRegion: 2,
    biweeklySelf: 11.25,
    biweeklySelfPlus: 22.49,
    biweeklyFamily: 33.74,
    monthlySelf: 24.38,
    monthlySelfPlus: 48.73,
    monthlyFamily: 73.1,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - Standard',
    ratingRegion: 3,
    biweeklySelf: 12.12,
    biweeklySelfPlus: 24.24,
    biweeklyFamily: 36.35,
    monthlySelf: 26.26,
    monthlySelfPlus: 52.52,
    monthlyFamily: 78.76,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - Standard',
    ratingRegion: 4,
    biweeklySelf: 12.79,
    biweeklySelfPlus: 25.58,
    biweeklyFamily: 38.37,
    monthlySelf: 27.71,
    monthlySelfPlus: 55.42,
    monthlyFamily: 83.14,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Delta Dentals Federal Employees Dental Program - Standard',
    ratingRegion: 5,
    biweeklySelf: 14.65,
    biweeklySelfPlus: 29.3,
    biweeklyFamily: 43.95,
    monthlySelf: 31.74,
    monthlySelfPlus: 63.48,
    monthlyFamily: 95.23,
    website: 'https://www1.deltadentalins.com/federal/fedvip/plans.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Delta_Dental_logo.svg',
  },
  {
    name: 'Dominion National - High',
    ratingRegion: 1,
    biweeklySelf: 9.84,
    biweeklySelfPlus: 19.68,
    biweeklyFamily: 29.52,
    monthlySelf: 21.32,
    monthlySelfPlus: 42.64,
    monthlyFamily: 63.96,
    website:
      'https://federal.dominionnational.com/wps/portal/dnf/fedvip-dental-plan-comparison',
    logo: 'https://federal.dominionnational.com/wps/wcm/connect/prodnws.dominionnational.com-30097/fafbd04a-cfde-47c7-ae5a-28364f0a8611/Dominion-logo.svg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_4G00HA41L84V20QEHJUBR820G1-fafbd04a-cfde-47c7-ae5a-28364f0a8611-oIUTSTH',
  },
  {
    name: 'Dominion National - High',
    ratingRegion: 2,
    biweeklySelf: 10.91,
    biweeklySelfPlus: 21.82,
    biweeklyFamily: 32.74,
    monthlySelf: 23.64,
    monthlySelfPlus: 47.28,
    monthlyFamily: 70.94,
    website:
      'https://federal.dominionnational.com/wps/portal/dnf/fedvip-dental-plan-comparison',
    logo: 'https://federal.dominionnational.com/wps/wcm/connect/prodnws.dominionnational.com-30097/fafbd04a-cfde-47c7-ae5a-28364f0a8611/Dominion-logo.svg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_4G00HA41L84V20QEHJUBR820G1-fafbd04a-cfde-47c7-ae5a-28364f0a8611-oIUTSTH',
  },
  {
    name: 'Dominion National - High',
    ratingRegion: 3,
    biweeklySelf: 14.51,
    biweeklySelfPlus: 29.02,
    biweeklyFamily: 43.54,
    monthlySelf: 31.44,
    monthlySelfPlus: 62.88,
    monthlyFamily: 94.34,
    website:
      'https://federal.dominionnational.com/wps/portal/dnf/fedvip-dental-plan-comparison',
    logo: 'https://federal.dominionnational.com/wps/wcm/connect/prodnws.dominionnational.com-30097/fafbd04a-cfde-47c7-ae5a-28364f0a8611/Dominion-logo.svg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_4G00HA41L84V20QEHJUBR820G1-fafbd04a-cfde-47c7-ae5a-28364f0a8611-oIUTSTH',
  },
  {
    name: 'Dominion National - Standard',
    ratingRegion: 1,
    biweeklySelf: 5.84,
    biweeklySelfPlus: 11.67,
    biweeklyFamily: 17.51,
    monthlySelf: 12.65,
    monthlySelfPlus: 25.29,
    monthlyFamily: 37.94,
    website:
      'https://federal.dominionnational.com/wps/portal/dnf/fedvip-dental-plan-comparison',
    logo: 'https://federal.dominionnational.com/wps/wcm/connect/prodnws.dominionnational.com-30097/fafbd04a-cfde-47c7-ae5a-28364f0a8611/Dominion-logo.svg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_4G00HA41L84V20QEHJUBR820G1-fafbd04a-cfde-47c7-ae5a-28364f0a8611-oIUTSTH',
  },
  {
    name: 'Dominion National - Standard',
    ratingRegion: 2,
    biweeklySelf: 7.46,
    biweeklySelfPlus: 14.92,
    biweeklyFamily: 22.38,
    monthlySelf: 16.16,
    monthlySelfPlus: 32.33,
    monthlyFamily: 48.49,
    website:
      'https://federal.dominionnational.com/wps/portal/dnf/fedvip-dental-plan-comparison',
    logo: 'https://federal.dominionnational.com/wps/wcm/connect/prodnws.dominionnational.com-30097/fafbd04a-cfde-47c7-ae5a-28364f0a8611/Dominion-logo.svg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_4G00HA41L84V20QEHJUBR820G1-fafbd04a-cfde-47c7-ae5a-28364f0a8611-oIUTSTH',
  },
  {
    name: 'Dominion National - Standard',
    ratingRegion: 3,
    biweeklySelf: 8.57,
    biweeklySelfPlus: 17.15,
    biweeklyFamily: 25.72,
    monthlySelf: 18.57,
    monthlySelfPlus: 37.16,
    monthlyFamily: 55.73,
    website:
      'https://federal.dominionnational.com/wps/portal/dnf/fedvip-dental-plan-comparison',
    logo: 'https://federal.dominionnational.com/wps/wcm/connect/prodnws.dominionnational.com-30097/fafbd04a-cfde-47c7-ae5a-28364f0a8611/Dominion-logo.svg?MOD=AJPERES&CACHEID=ROOTWORKSPACE.Z18_4G00HA41L84V20QEHJUBR820G1-fafbd04a-cfde-47c7-ae5a-28364f0a8611-oIUTSTH',
  },
  {
    name: 'EmblemHealth Dental - High',
    ratingRegion: 1,
    biweeklySelf: 31.83,
    biweeklySelfPlus: 63.6,
    biweeklyFamily: 95.43,
    monthlySelf: 68.97,
    monthlySelfPlus: 137.8,
    monthlyFamily: 206.77,
    website:
      'https://www.emblemhealth.com/resources/federal-employees/fedvip-dental',
    logo: 'https://www.emblemhealth.com/content/dam/emblemhealth/images/logos/eh-logo-2022.svg',
  },
  {
    name: 'EmblemHealth Dental - Standard',
    ratingRegion: 1,
    biweeklySelf: 21.16,
    biweeklySelfPlus: 42.29,
    biweeklyFamily: 63.46,
    monthlySelf: 45.85,
    monthlySelfPlus: 91.63,
    monthlyFamily: 137.5,
    website:
      'https://www.emblemhealth.com/resources/federal-employees/fedvip-dental',
    logo: 'https://www.emblemhealth.com/content/dam/emblemhealth/images/logos/eh-logo-2022.svg',
  },
  {
    name: 'GEHA Connection Dental Federal - High',
    ratingRegion: 0,
    biweeklySelf: 28.23,
    biweeklySelfPlus: 56.46,
    biweeklyFamily: 84.63,
    monthlySelf: 61.17,
    monthlySelfPlus: 122.33,
    monthlyFamily: 183.37,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - High',
    ratingRegion: 1,
    biweeklySelf: 18.97,
    biweeklySelfPlus: 37.92,
    biweeklyFamily: 56.88,
    monthlySelf: 41.1,
    monthlySelfPlus: 82.16,
    monthlyFamily: 123.24,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - High',
    ratingRegion: 2,
    biweeklySelf: 21.32,
    biweeklySelfPlus: 42.62,
    biweeklyFamily: 63.95,
    monthlySelf: 46.19,
    monthlySelfPlus: 92.34,
    monthlyFamily: 138.56,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - High',
    ratingRegion: 3,
    biweeklySelf: 23.26,
    biweeklySelfPlus: 46.53,
    biweeklyFamily: 69.79,
    monthlySelf: 50.4,
    monthlySelfPlus: 100.82,
    monthlyFamily: 151.21,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - High',
    ratingRegion: 4,
    biweeklySelf: 26.05,
    biweeklySelfPlus: 52.08,
    biweeklyFamily: 78.13,
    monthlySelf: 56.44,
    monthlySelfPlus: 112.84,
    monthlyFamily: 169.28,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - High',
    ratingRegion: 5,
    biweeklySelf: 28.23,
    biweeklySelfPlus: 56.46,
    biweeklyFamily: 84.63,
    monthlySelf: 61.17,
    monthlySelfPlus: 122.33,
    monthlyFamily: 183.37,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - Standard',
    ratingRegion: 0,
    biweeklySelf: 16,
    biweeklySelfPlus: 32,
    biweeklyFamily: 48,
    monthlySelf: 34.67,
    monthlySelfPlus: 69.33,
    monthlyFamily: 104,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - Standard',
    ratingRegion: 1,
    biweeklySelf: 10.82,
    biweeklySelfPlus: 21.61,
    biweeklyFamily: 32.41,
    monthlySelf: 23.44,
    monthlySelfPlus: 46.82,
    monthlyFamily: 70.22,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - Standard',
    ratingRegion: 2,
    biweeklySelf: 12.11,
    biweeklySelfPlus: 24.22,
    biweeklyFamily: 36.24,
    monthlySelf: 26.24,
    monthlySelfPlus: 52.48,
    monthlyFamily: 78.52,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - Standard',
    ratingRegion: 3,
    biweeklySelf: 13.27,
    biweeklySelfPlus: 26.48,
    biweeklyFamily: 39.75,
    monthlySelf: 28.75,
    monthlySelfPlus: 57.37,
    monthlyFamily: 86.13,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - Standard',
    ratingRegion: 4,
    biweeklySelf: 14.81,
    biweeklySelfPlus: 29.6,
    biweeklyFamily: 44.39,
    monthlySelf: 32.09,
    monthlySelfPlus: 64.13,
    monthlyFamily: 96.18,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'GEHA Connection Dental Federal - Standard',
    ratingRegion: 5,
    biweeklySelf: 16,
    biweeklySelfPlus: 32,
    biweeklyFamily: 48,
    monthlySelf: 34.67,
    monthlySelfPlus: 69.33,
    monthlyFamily: 104,
    website: 'https://www.geha.com/plans/dental/2024/overview',
    logo: 'https://www.geha.com/~/media93/Project/GEHA/GEHA/geha-logos/geha_logo_rgb_full_wflag_midnight.png',
  },
  {
    name: 'Humana Dental - High',
    ratingRegion: 1,
    biweeklySelf: 21.73,
    biweeklySelfPlus: 43.47,
    biweeklyFamily: 65.2,
    monthlySelf: 47.08,
    monthlySelfPlus: 94.19,
    monthlyFamily: 141.27,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - High',
    ratingRegion: 2,
    biweeklySelf: 23.88,
    biweeklySelfPlus: 47.76,
    biweeklyFamily: 71.64,
    monthlySelf: 51.74,
    monthlySelfPlus: 103.48,
    monthlyFamily: 155.22,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - High',
    ratingRegion: 3,
    biweeklySelf: 25.06,
    biweeklySelfPlus: 50.13,
    biweeklyFamily: 75.19,
    monthlySelf: 54.3,
    monthlySelfPlus: 108.62,
    monthlyFamily: 162.91,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - High',
    ratingRegion: 4,
    biweeklySelf: 26.8,
    biweeklySelfPlus: 53.6,
    biweeklyFamily: 80.4,
    monthlySelf: 58.07,
    monthlySelfPlus: 116.13,
    monthlyFamily: 174.2,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - High',
    ratingRegion: 5,
    biweeklySelf: 32.24,
    biweeklySelfPlus: 64.47,
    biweeklyFamily: 96.71,
    monthlySelf: 69.85,
    monthlySelfPlus: 139.69,
    monthlyFamily: 209.54,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - Standard',
    ratingRegion: 1,
    biweeklySelf: 11.94,
    biweeklySelfPlus: 23.89,
    biweeklyFamily: 35.83,
    monthlySelf: 25.87,
    monthlySelfPlus: 51.76,
    monthlyFamily: 77.63,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - Standard',
    ratingRegion: 2,
    biweeklySelf: 12.87,
    biweeklySelfPlus: 25.74,
    biweeklyFamily: 38.6,
    monthlySelf: 27.89,
    monthlySelfPlus: 55.77,
    monthlyFamily: 83.63,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - Standard',
    ratingRegion: 3,
    biweeklySelf: 13.88,
    biweeklySelfPlus: 27.76,
    biweeklyFamily: 41.64,
    monthlySelf: 30.07,
    monthlySelfPlus: 60.15,
    monthlyFamily: 90.22,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - Standard',
    ratingRegion: 4,
    biweeklySelf: 15.24,
    biweeklySelfPlus: 30.49,
    biweeklyFamily: 45.73,
    monthlySelf: 33.02,
    monthlySelfPlus: 66.06,
    monthlyFamily: 99.08,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'Humana Dental - Standard',
    ratingRegion: 5,
    biweeklySelf: 17.49,
    biweeklySelfPlus: 34.98,
    biweeklyFamily: 52.47,
    monthlySelf: 37.9,
    monthlySelfPlus: 75.79,
    monthlyFamily: 113.69,
    website: 'https://your.humana.com/feds/dental.html',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Humana_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - High',
    ratingRegion: 0,
    biweeklySelf: 25.9,
    biweeklySelfPlus: 51.8,
    biweeklyFamily: 77.69,
    monthlySelf: 56.12,
    monthlySelfPlus: 112.23,
    monthlyFamily: 168.33,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - High',
    ratingRegion: 1,
    biweeklySelf: 18.81,
    biweeklySelfPlus: 37.62,
    biweeklyFamily: 56.42,
    monthlySelf: 40.76,
    monthlySelfPlus: 81.51,
    monthlyFamily: 122.24,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - High',
    ratingRegion: 2,
    biweeklySelf: 19.92,
    biweeklySelfPlus: 39.84,
    biweeklyFamily: 59.76,
    monthlySelf: 43.16,
    monthlySelfPlus: 86.32,
    monthlyFamily: 129.48,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - High',
    ratingRegion: 3,
    biweeklySelf: 21.78,
    biweeklySelfPlus: 43.56,
    biweeklyFamily: 65.35,
    monthlySelf: 47.19,
    monthlySelfPlus: 94.38,
    monthlyFamily: 141.59,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - High',
    ratingRegion: 4,
    biweeklySelf: 23.72,
    biweeklySelfPlus: 47.43,
    biweeklyFamily: 71.15,
    monthlySelf: 51.39,
    monthlySelfPlus: 102.77,
    monthlyFamily: 154.16,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - High',
    ratingRegion: 5,
    biweeklySelf: 25.9,
    biweeklySelfPlus: 51.8,
    biweeklyFamily: 77.69,
    monthlySelf: 56.12,
    monthlySelfPlus: 112.23,
    monthlyFamily: 168.33,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - Standard',
    ratingRegion: 0,
    biweeklySelf: 14.34,
    biweeklySelfPlus: 28.68,
    biweeklyFamily: 43.02,
    monthlySelf: 31.07,
    monthlySelfPlus: 62.14,
    monthlyFamily: 93.21,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - Standard',
    ratingRegion: 1,
    biweeklySelf: 10.89,
    biweeklySelfPlus: 21.77,
    biweeklyFamily: 32.66,
    monthlySelf: 23.6,
    monthlySelfPlus: 47.17,
    monthlyFamily: 70.76,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - Standard',
    ratingRegion: 2,
    biweeklySelf: 11.56,
    biweeklySelfPlus: 23.11,
    biweeklyFamily: 34.67,
    monthlySelf: 25.05,
    monthlySelfPlus: 50.07,
    monthlyFamily: 75.12,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - Standard',
    ratingRegion: 3,
    biweeklySelf: 12.57,
    biweeklySelfPlus: 25.14,
    biweeklyFamily: 37.71,
    monthlySelf: 27.24,
    monthlySelfPlus: 54.47,
    monthlyFamily: 81.71,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - Standard',
    ratingRegion: 4,
    biweeklySelf: 13.67,
    biweeklySelfPlus: 27.34,
    biweeklyFamily: 41.01,
    monthlySelf: 29.62,
    monthlySelfPlus: 59.24,
    monthlyFamily: 88.86,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'The MetLife Federal Dental Plan - Standard',
    ratingRegion: 5,
    biweeklySelf: 14.34,
    biweeklySelfPlus: 28.68,
    biweeklyFamily: 43.02,
    monthlySelf: 31.07,
    monthlySelfPlus: 62.14,
    monthlyFamily: 93.21,
    website: 'https://fedvip.metlife.com/dental/plan-details/',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/c/c6/MetLife_logo.svg',
  },
  {
    name: 'Triple-S Salud - High',
    ratingRegion: 1,
    biweeklySelf: 6.19,
    biweeklySelfPlus: 12.38,
    biweeklyFamily: 16.17,
    monthlySelf: 13.41,
    monthlySelfPlus: 26.82,
    monthlyFamily: 35.04,
    website:
      'https://salud.grupotriples.com/en/health-insurance-plans/federal-employees-supplementary-dental-plan/',
    logo: 'https://salud.grupotriples.com/wp-content/themes/triples-salud/assets/images/508/logo.svg',
  },
  {
    name: 'United Concordia Dental - High',
    ratingRegion: 0,
    biweeklySelf: 27.38,
    biweeklySelfPlus: 54.76,
    biweeklyFamily: 82.12,
    monthlySelf: 59.32,
    monthlySelfPlus: 118.65,
    monthlyFamily: 177.93,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - High',
    ratingRegion: 1,
    biweeklySelf: 18.36,
    biweeklySelfPlus: 36.71,
    biweeklyFamily: 55.06,
    monthlySelf: 39.78,
    monthlySelfPlus: 79.54,
    monthlyFamily: 119.3,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - High',
    ratingRegion: 2,
    biweeklySelf: 20.61,
    biweeklySelfPlus: 41.2,
    biweeklyFamily: 61.81,
    monthlySelf: 44.66,
    monthlySelfPlus: 89.27,
    monthlyFamily: 133.92,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - High',
    ratingRegion: 3,
    biweeklySelf: 22.88,
    biweeklySelfPlus: 45.74,
    biweeklyFamily: 68.62,
    monthlySelf: 49.57,
    monthlySelfPlus: 99.1,
    monthlyFamily: 148.68,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - High',
    ratingRegion: 4,
    biweeklySelf: 25.13,
    biweeklySelfPlus: 50.24,
    biweeklyFamily: 75.37,
    monthlySelf: 54.45,
    monthlySelfPlus: 108.85,
    monthlyFamily: 163.3,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - High',
    ratingRegion: 5,
    biweeklySelf: 27.38,
    biweeklySelfPlus: 54.76,
    biweeklyFamily: 82.12,
    monthlySelf: 59.32,
    monthlySelfPlus: 118.65,
    monthlyFamily: 177.93,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - Standard',
    ratingRegion: 0,
    biweeklySelf: 16.21,
    biweeklySelfPlus: 32.42,
    biweeklyFamily: 48.64,
    monthlySelf: 35.12,
    monthlySelfPlus: 70.24,
    monthlyFamily: 105.39,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - Standard',
    ratingRegion: 1,
    biweeklySelf: 10.93,
    biweeklySelfPlus: 21.83,
    biweeklyFamily: 32.76,
    monthlySelf: 23.68,
    monthlySelfPlus: 47.3,
    monthlyFamily: 70.98,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - Standard',
    ratingRegion: 2,
    biweeklySelf: 12.26,
    biweeklySelfPlus: 24.5,
    biweeklyFamily: 36.74,
    monthlySelf: 26.56,
    monthlySelfPlus: 53.08,
    monthlyFamily: 79.6,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - Standard',
    ratingRegion: 3,
    biweeklySelf: 13.58,
    biweeklySelfPlus: 27.16,
    biweeklyFamily: 40.73,
    monthlySelf: 29.42,
    monthlySelfPlus: 58.85,
    monthlyFamily: 88.25,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - Standard',
    ratingRegion: 4,
    biweeklySelf: 14.9,
    biweeklySelfPlus: 29.79,
    biweeklyFamily: 44.7,
    monthlySelf: 32.28,
    monthlySelfPlus: 64.55,
    monthlyFamily: 96.85,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'United Concordia Dental - Standard',
    ratingRegion: 5,
    biweeklySelf: 16.21,
    biweeklySelfPlus: 32.42,
    biweeklyFamily: 48.64,
    monthlySelf: 35.12,
    monthlySelfPlus: 70.24,
    monthlyFamily: 105.39,
    website: 'https://www.uccifedvip.com/our-plans',
    logo: 'https://www.uccifedvip.com/content/dam/ucd/en/commercial/fedvip/images/logos/UCD-logo-header.png',
  },
  {
    name: 'UnitedHealthcare Dental Plan - High',
    ratingRegion: 0,
    biweeklySelf: 33.13,
    biweeklySelfPlus: 66.26,
    biweeklyFamily: 99.39,
    monthlySelf: 71.78,
    monthlySelfPlus: 143.56,
    monthlyFamily: 215.35,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - High',
    ratingRegion: 1,
    biweeklySelf: 22.2,
    biweeklySelfPlus: 44.41,
    biweeklyFamily: 66.61,
    monthlySelf: 48.1,
    monthlySelfPlus: 96.22,
    monthlyFamily: 144.32,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - High',
    ratingRegion: 2,
    biweeklySelf: 23.31,
    biweeklySelfPlus: 46.63,
    biweeklyFamily: 69.94,
    monthlySelf: 50.51,
    monthlySelfPlus: 101.03,
    monthlyFamily: 151.54,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - High',
    ratingRegion: 3,
    biweeklySelf: 24.52,
    biweeklySelfPlus: 49.03,
    biweeklyFamily: 73.55,
    monthlySelf: 53.13,
    monthlySelfPlus: 106.23,
    monthlyFamily: 159.36,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - High',
    ratingRegion: 4,
    biweeklySelf: 28.21,
    biweeklySelfPlus: 56.42,
    biweeklyFamily: 84.64,
    monthlySelf: 61.12,
    monthlySelfPlus: 122.24,
    monthlyFamily: 183.39,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - High',
    ratingRegion: 5,
    biweeklySelf: 33.13,
    biweeklySelfPlus: 66.26,
    biweeklyFamily: 99.39,
    monthlySelf: 71.78,
    monthlySelfPlus: 143.56,
    monthlyFamily: 215.35,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - Standard',
    ratingRegion: 0,
    biweeklySelf: 18.85,
    biweeklySelfPlus: 37.7,
    biweeklyFamily: 56.54,
    monthlySelf: 40.84,
    monthlySelfPlus: 81.68,
    monthlyFamily: 122.5,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - Standard',
    ratingRegion: 1,
    biweeklySelf: 12.68,
    biweeklySelfPlus: 25.36,
    biweeklyFamily: 38.04,
    monthlySelf: 27.47,
    monthlySelfPlus: 54.95,
    monthlyFamily: 82.42,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - Standard',
    ratingRegion: 2,
    biweeklySelf: 14.33,
    biweeklySelfPlus: 28.66,
    biweeklyFamily: 42.99,
    monthlySelf: 31.05,
    monthlySelfPlus: 62.1,
    monthlyFamily: 93.15,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - Standard',
    ratingRegion: 3,
    biweeklySelf: 15.4,
    biweeklySelfPlus: 30.81,
    biweeklyFamily: 46.21,
    monthlySelf: 33.37,
    monthlySelfPlus: 66.76,
    monthlyFamily: 100.12,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - Standard',
    ratingRegion: 4,
    biweeklySelf: 16.22,
    biweeklySelfPlus: 32.45,
    biweeklyFamily: 48.67,
    monthlySelf: 35.14,
    monthlySelfPlus: 70.31,
    monthlyFamily: 105.45,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
  {
    name: 'UnitedHealthcare Dental Plan - Standard',
    ratingRegion: 5,
    biweeklySelf: 18.85,
    biweeklySelfPlus: 37.7,
    biweeklyFamily: 56.54,
    monthlySelf: 40.84,
    monthlySelfPlus: 81.68,
    monthlyFamily: 122.5,
    website: 'https://member.uhc.com/sbd/dental',
    logo: 'https://upload.wikimedia.org/wikipedia/en/2/29/UnitedHealthcare_%28logo%29.svg',
  },
]
